module.exports = __webpack_public_path__ + "img/icon_ai_change@3x.9794e6e5.png";